const constant = {
    DELETE_TRANSACTION:'DELETE_TRANSACTION',
    ADD_TRANSACTION:'ADD_TRANSACTION',
    SEARCH_TRANSACTION:'SEARCH_TRANSACTION'
};
export {constant};